import {
  FETCH_QUOTE,
  ACCEPT_QUOTE,
  DECLINE_QUOTE,
  CREATE_QUOTE,
  FETCH_QUOTE_FOR_REQUEST_START,
  FETCH_QUOTE_FOR_REQUEST,
  FETCH_QUOTE_FOR_REQUEST_ERROR,
  FETCH_PUBLIC_QUOTE_START,
  FETCH_PUBLIC_QUOTE,
  FETCH_PUBLIC_QUOTE_ERROR,
  FETCH_QUOTE_BY_UUID_START,
  FETCH_QUOTE_BY_UUID,
  FETCH_QUOTE_BY_UUID_ERROR,
  RESET_QUOTE,
} from '../constants/action-types';

const initialState = {
  quote: null,
  publicQuote: null,
  loading: true,
  error: null,
  viewType: null, // 'shared' | 'customer'
};

export default function (state = initialState, action) {
  switch (action.type) {
    case FETCH_QUOTE:
    case ACCEPT_QUOTE:
    case DECLINE_QUOTE:
      return { ...action.payload };
    case CREATE_QUOTE:
      return state;

    case FETCH_QUOTE_FOR_REQUEST_START:
    case FETCH_PUBLIC_QUOTE_START:
    case FETCH_QUOTE_BY_UUID_START:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case FETCH_QUOTE_FOR_REQUEST:
      return {
        ...state,
        quote: action.payload,
        publicQuote: null,
        loading: false,
        viewType: 'customer',
      };

    case FETCH_PUBLIC_QUOTE:
      return {
        ...state,
        publicQuote: action.payload,
        quote: null,
        loading: false,
        viewType: 'shared',
      };

    case FETCH_QUOTE_BY_UUID:
      return {
        ...state,
        quote: action.payload,
        publicQuote: null,
        loading: false,
        viewType: 'customer',
      };

    case FETCH_QUOTE_FOR_REQUEST_ERROR:
    case FETCH_PUBLIC_QUOTE_ERROR:
    case FETCH_QUOTE_BY_UUID_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case RESET_QUOTE:
      return initialState;

    default:
      return state;
  }
}
